import React from "react";
import { Box, Typography } from "@mui/material";

interface Props {
  description: string | undefined;
}
const PlannerDescription = ({ description }: Props) => (
  <Box className="planner-description">
    <Typography
      sx={{
        color: "#656461",
      }}
    >
      {description}
    </Typography>
  </Box>
);

export default PlannerDescription;
